import { MEASUREMENT_TYPES } from "../../../../../config/enums/MeasurementTypes";
import { MaterialFormValues } from "../types/packagingMaterial.types";

export const EMPTY_MATERIAL: MaterialFormValues = {
  name: "",
  material: "",
  weight: "",
  weightUnit: String(MEASUREMENT_TYPES.WEIGHT_KG),
  cost: ""
};
